import { useQuery } from '@apollo/client';
import loadable from '@loadable/component';
import Loader from 'Components/Forms/Loader';
import { useLogEventOnMount } from 'hooks/useLogEvent';
import { GET_PRODUCT } from 'graphql/secure/queries';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TRouteParamsWithId } from 'types/router.types';
import ErrorState from 'Components/ErrorState';

const LoadableAnalytics = loadable(
  () => import('FeatureModules/ProductPage/Components/BehaviorAnalytics'),
  {
    fallback: <Loader />,
  }
);

const ProductBehaviorAnalytics = () => {
  const { id } = useParams<TRouteParamsWithId>();
  useLogEventOnMount('VIEW_PRODUCT_BEHAVIOUR_ANALYTICS', { productId: id });
  const { error, loading, data } = useQuery(GET_PRODUCT, {
    variables: { id },
  });

  useEffect(() => {
    LoadableAnalytics.preload();
  }, []);

  if (error) return <ErrorState error={error} />;
  if (!data && loading) return <Loader />;

  return <LoadableAnalytics />;
};

export default ProductBehaviorAnalytics;
